import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'grade-card',
})
export default class TaxonomyTags extends Vue {
  // --------------------------------------------------------------
  // Properties

  @Prop()
  public grades: any;

  @Prop({ default: 1 })
  public visibleCount!: number;

  public get visibleItems() {
    const grades = this.grades;
    return grades.slice(0, this.visibleCount);
  }

  public get noVisibleItems() {
    const grades = this.grades;
    return grades.slice(this.visibleCount, grades.length);
  }

  public get hasMoreTags() {
    const grades = this.grades;
    return grades.length > this.visibleCount;
  }

  // --------------------------------------------------------------
  // Hooks

  // --------------------------------------------------------------
  // Actions

  // --------------------------------------------------------------
  // Methods
}
